import { useEffect, useState, useRef } from 'react';
import { Loader2, ImageOff } from 'lucide-react';

/**
 * Renders an authenticated image via blob fetch (so the Authorization
 * header is honoured — `<img src>` can't send custom headers).
 */
export default function AuthImage({ src, alt = '', className, onClick, dataTestId }) {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState(false);
  const objectUrlRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    setError(false);
    setUrl(null);
    if (!src) return;
    (async () => {
      try {
        const token = localStorage.getItem('session_token') || localStorage.getItem('access_token');
        const res = await fetch(src, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const blob = await res.blob();
        if (cancelled) return;
        const u = URL.createObjectURL(blob);
        objectUrlRef.current = u;
        setUrl(u);
      } catch (e) {
        if (!cancelled) setError(true);
      }
    })();
    return () => {
      cancelled = true;
      if (objectUrlRef.current) {
        URL.revokeObjectURL(objectUrlRef.current);
        objectUrlRef.current = null;
      }
    };
  }, [src]);

  if (error) {
    return (
      <div className={`flex items-center justify-center bg-black/10 ${className || ''}`}>
        <ImageOff className="w-5 h-5 opacity-40" />
      </div>
    );
  }
  if (!url) {
    return (
      <div className={`flex items-center justify-center bg-black/10 ${className || ''}`}>
        <Loader2 className="w-5 h-5 animate-spin opacity-40" />
      </div>
    );
  }
  return (
    <img
      src={url}
      alt={alt}
      className={className}
      onClick={onClick}
      data-testid={dataTestId}
    />
  );
}
